import React, { useState, useMemo } from "react";
import {
  Container,
  Row,
  Col,
  Button,
  FormGroup,
  InputGroup,
  FormControl,
} from "react-bootstrap";
import { injectIntl } from "react-intl";

import SessionRow from "../../../components/scheduleRows/sessionsrow";
import ArchiveHeader from "../../../components/ArchiveHeader";
import PageLoading from "../../../components/Loading";

import Alert from "react-s-alert";
import { useQuery, useMutation, queryCache } from "react-query";

import { getSchedule, deleteSchedule } from '../schedules/xhr';

import CreateItemForm from '../../../components/CreateItemForm';
import Table from '../../../components/TableNew';



const Sessions = ({ intl, locale, setLocale }) => {
  const [search, setSearch] = useState("");
  const [sessionName, setSessionName] = useState('')

  const { isLoading, isError, error, data: schedule } = useQuery('schedule', getSchedule, {
    onError: (err) => {
      Alert.error(intl.formatMessage({ id: err.response.data.message }))
    }
  });

  const [deleteSessionMutation] = useMutation(deleteSchedule, {
    onSuccess: (deletedSession) => {
      if(queryCache.getQueryData('schedule')) {
        queryCache.setQueryData('schedule', schedule => ({
          ...schedule,
          sessions: schedule.sessions.filter(association => association._id !== deletedSession._id)
        }))
      }
      Alert.success(intl.formatMessage({ id: 'session.delete-success' }));
    },
    onError: (err) => {
      Alert.error(intl.formatMessage({ id: err.response.data.message }))
    }
  })


  const columns = useMemo(
    () => [
      {
        Header: "Sessions",
        accessor: ({ _id, ...row }) => {
          return Object.values(row).join("|");
        },
        Cell: ({ cell: { value }, row: { original } }) => (
          // <pre>{JSON.stringify(original, null, 2)}</pre>
          <SessionRow
            key={original._id}
            id={original._id}
            name={original.name}
            description={original.description}
            deleteFn={(collection,_id) => {
              deleteSessionMutation({collection, _id })
            }}
          />
        ),
      },
    ],
    [deleteSessionMutation]
  );

  if (isLoading) {
    return <PageLoading />;
  }

  if (isError) {
    return <span>Error: {error.message}</span>
  }

  return (
    <React.Fragment>
      <ArchiveHeader locale={locale} setLocale={setLocale} intl={intl} title="tab.schedule-sessions" />
      <div className="pad-2rem">
        <Container fluid>
          <Row className="align-items-center m-b-20">
            <Col lg={6}>
            <CreateItemForm
                heading="button.s.session-create"
                setFunc={setSessionName}
                placeholder={intl.formatMessage({ id: 'button.s.session-create' })}
                link={`/session/add/${sessionName}`}
              />
            </Col>
            <Col lg={6}>
              <Row>
                <Col></Col>
                <Col md={5}>
                  <div className="text-right search-container">
                    <FormGroup>
                      <InputGroup onChange={(e) => setSearch(e.target.value)}>
                        <FormControl type="text" />
                        <InputGroup.Append>
                          <Button>
                            <img src="/icons/search.png" alt="plus" />
                          </Button>
                        </InputGroup.Append>
                      </InputGroup>
                    </FormGroup>
                  </div>
                </Col>
              </Row>
            </Col>
          </Row>
          <Row>
            <Col>
              <Table columns={columns} data={schedule.sessions} search={search} intl={intl} />
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};


export default injectIntl(Sessions);
